module.exports = __webpack_public_path__ + "static/img/component.50929dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cause_analyse/component.png
// module id = v4ta
// module chunks = 82